const getUserAgent = () => {
  return window.navigator.userAgent;
};

export default getUserAgent;
